import React, { ComponentProps, ReactNode } from 'react';
import { useScrolled } from '../../core/hooks/use-scrolled';
import { AddToCartSection } from '../add-to-cart-section/add-to-cart-section';
import { GridContainer, GridItem } from '../grid/grid';
import { PageHeader } from '../page-header/page-header';
import styles from './page-header-article-details-layout.module.scss';

const SCROLL_LIMIT_HEADER_OUT_OF_VIEWPORT = 566;

type AddToCartSectionState = ComponentProps<typeof AddToCartSection>['state'];

type AddToCartSectionChildProps = {
  state: AddToCartSectionState;
};

type Props = {
  backLink: ReactNode;
  colorSample: ReactNode;
  articleInformation: ReactNode;
  addToCartSection: (props: AddToCartSectionChildProps) => ReactNode;
};

const BackLink: React.FC<{ children: ReactNode }> = ({ children }) => <div className={styles.backLink}>{children}</div>;

export const PageHeaderArticleDetailsLayout: React.FC<Props> = ({
  backLink,
  colorSample,
  articleInformation,
  addToCartSection,
}) => {
  const isScrolled = useScrolled(undefined, 50);
  const isScrolledFar = useScrolled(undefined, SCROLL_LIMIT_HEADER_OUT_OF_VIEWPORT);

  let addToCartSectionState: AddToCartSectionState = 'darkBg';
  if (isScrolled) addToCartSectionState = 'lightBg';
  if (isScrolledFar) addToCartSectionState = 'lightBgExpanded';

  return (
    <>
      <div className={styles.overlay}>
        <GridContainer className={styles.gridContainerOverlay}>
          <GridItem span="9" />
          <GridItem span="3">
            <div className={styles.addToCartSectionContainer}>{addToCartSection({ state: addToCartSectionState })}</div>
          </GridItem>
        </GridContainer>
      </div>
      <PageHeader variant="articleDetails">
        <GridContainer className={styles.root}>
          <GridItem className={styles.backLinkContainerDesktop} span="2">
            <BackLink>{backLink}</BackLink>
          </GridItem>
          <GridItem span="7">
            <div className={styles.mainInformation}>
              {colorSample}
              {articleInformation}
            </div>
            <div className={styles.backLinkContainerTablet}>
              <BackLink>{backLink}</BackLink>
            </div>
          </GridItem>
          <GridItem className={styles.addToCartSectionContainerMobile}>
            {addToCartSection({ state: 'lightBg' })}
          </GridItem>
          <GridItem className={styles.addToCartSectionContainerMobile}>
            <BackLink>{backLink}</BackLink>
          </GridItem>
        </GridContainer>
      </PageHeader>
    </>
  );
};
